export const ExternalCounterSection = ({
  isMembershipSummaryLoading,
  totalMemberships,
  pendingApprovals,
  incompleteAffiliations,
  onGoToSalesBase,
  onGoToPendingApprovals,
  onGoToIncompleteAffiliations,
  onGoToRenewalModule,
  onGoToNewAffiliation,
}) => {
  return (
    <div className="external-counter-section">
      <h5 className="external-counter-title">RESUMEN DE AFILIACIONES</h5>
      {isMembershipSummaryLoading && (
        <p className="external-counter-loading-message">
          Cargando resumen de afiliaciones...
        </p>
      )}
      <div className="external-counter-summary-grid">
        <div
          className="external-counter-summary-card"
          onClick={onGoToSalesBase}
          style={{ cursor: 'pointer' }}
        >
          <span className="external-counter-summary-icon check">✓</span>
          <p className="external-counter-summary-label">Mis Ventas</p>
          <h2 className="external-counter-summary-value">
            {isMembershipSummaryLoading ? '...' : totalMemberships ?? 0}
          </h2>
          <p className="external-counter-summary-footnote">Total registradas</p>
        </div>
        <div
          className="external-counter-summary-card"
          onClick={onGoToPendingApprovals}
          style={{ cursor: 'pointer' }}
        >
          <span className="external-counter-summary-icon pending">◔</span>
          <p className="external-counter-summary-label">Afiliaciones por aprobar</p>
          <h2 className="external-counter-summary-value">
            {isMembershipSummaryLoading ? '...' : pendingApprovals ?? 0}
          </h2>
        </div>
        <div
          className="external-counter-summary-card"
          onClick={onGoToIncompleteAffiliations}
          style={{ cursor: 'pointer' }}
        >
          <span className="external-counter-summary-icon incomplete">=</span>
          <p className="external-counter-summary-label">Afiliaciones incompletas</p>
          <h2 className="external-counter-summary-value">
            {isMembershipSummaryLoading
              ? '...'
              : typeof incompleteAffiliations === 'number'
                ? incompleteAffiliations
                : '-'}
          </h2>
        </div>
      </div>

      <h5 className="external-counter-title">ACCIONES RÁPIDAS</h5>
      <div className="external-counter-quick-actions-grid">
        <button
          type="button"
          className="external-counter-quick-action renewal"
          onClick={onGoToRenewalModule}
        >
          <div className="external-counter-quick-action-content">
            <span className="external-counter-quick-action-icon renewal">↻</span>
            <div>
              <h6>Módulo de renovación</h6>
              <p>Gestionar afiliaciones a renovar</p>
            </div>
          </div>
          <span className="external-counter-quick-action-arrow">→</span>
        </button>
        <button
          type="button"
          className="external-counter-quick-action affiliation"
          onClick={onGoToNewAffiliation}
        >
          <div className="external-counter-quick-action-content">
            <span className="external-counter-quick-action-icon affiliation">⊕</span>
            <div>
              <h6>Nueva afiliación</h6>
              <p>Ir al landing de nuevas afiliaciones</p>
            </div>
          </div>
          <span className="external-counter-quick-action-arrow">→</span>
        </button>
      </div>
    </div>
  );
};
